import { createSlice } from "@reduxjs/toolkit";

import {
  fetchSessionInfos,
  fetchSessionInfoById,
  addSessionInfo,
  updateSessionInfo,
  deleteSessionInfo,
} from "./sessionInfo.thunk";

const initialState = {
  sessionInfos: [],
  totalPages: 1,
  currentPage: 1,
  total: 0,
  limit: 10,
  loading: false,
  error: null,
  selectedSessionInfo: null,
};

const sessionInfoSlice = createSlice({
  name: "sessionInfo",

  initialState,

  reducers: {
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload;
    },

    setSelectedSessionInfo: (state, action) => {
      state.selectedSessionInfo = action.payload;
    },

    clearSelectedSessionInfo: (state) => {
      state.selectedSessionInfo = null;
    },
  },

  extraReducers: (builder) => {
    builder

      /* ============================================================
         FETCH SESSION INFO LIST
      ============================================================ */

      .addCase(fetchSessionInfos.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchSessionInfos.fulfilled, (state, action) => {
        state.loading = false;
        // Optional structural defensive fallback layers added
        state.sessionInfos = action.payload?.data || [];
        state.totalPages = action.payload?.meta?.total_pages || 1;
        state.total = action.payload?.meta?.total || 0;
        state.limit = action.payload?.meta?.limit || 10;
      })

      .addCase(fetchSessionInfos.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ============================================================
         FETCH SINGLE SESSION INFO (DETAILED INSTANCE WITH ROSTER)
      ============================================================ */

      .addCase(fetchSessionInfoById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchSessionInfoById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedSessionInfo = action.payload;
      })

      .addCase(fetchSessionInfoById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ============================================================
         ADD SESSION INFO
      ============================================================ */

      .addCase(addSessionInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(addSessionInfo.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(addSessionInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ============================================================
         UPDATE SESSION INFO
      ============================================================ */

      .addCase(updateSessionInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(updateSessionInfo.fulfilled, (state) => {
        state.loading = false;
      })

      .addCase(updateSessionInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      /* ============================================================
         DELETE SESSION INFO
      ============================================================ */

      .addCase(deleteSessionInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(deleteSessionInfo.fulfilled, (state, action) => {
        state.loading = false;
        
        // Ensure state list handles array filters safely
        const targetId = action.payload?.id;
        state.sessionInfos = (state.sessionInfos || []).filter(
          (instance) => instance.id !== targetId
        );
        if (state.selectedSessionInfo?.id === targetId) {
          state.selectedSessionInfo = null;
        }
      })

      .addCase(deleteSessionInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  setCurrentPage,
  setSelectedSessionInfo,
  clearSelectedSessionInfo,
} = sessionInfoSlice.actions;

export default sessionInfoSlice.reducer;